export const appPages = {
	dashboardPage: {
		id: 'dashboardPage',
		to: '/',
		text: 'Dashboard',
		icon: 'HeroRectangleGroup',
	},
	subscriptionPage: {
		id: 'subscriptionPage',
		to: '/subscription',
		text: 'Subscription',
		icon: 'DuoDollar',
	},
	// salesAppPages: {
	// 	id: 'salesApp',
	// 	to: '/sales',
	// 	text: 'Sales',
	// 	icon: 'HeroBanknotes',
	// },
	profilePage: {
		id: 'profilePage',
		to: '/profile',
		text: 'Profile',
		icon: 'HeroUser',
	},
	patientPage: {
		id: 'patientPage',
		to: '/patient',
		text: '',
		icon: '',
	},
	patientForm: {
		id: 'patientForm',
		to: '/form',
		text: 'Forms',
		icon: 'HeroServer',
	},
	addPatientPage: {
		id: 'addPatientPage',
		text: 'Add Patient',
		icon: 'HeroUserPlus',
	},
	newCases: {
		id: 'newCases',
		to: '/new-note-case',
		text: '',
		icon: '',
	},
	soapDetails: {
		id: 'soapDetails',
		to: '/soap',
		text: '',
		icon: '',
	},
};

export const authPages = {
	loginPage: {
		id: 'loginPage',
		to: '/login',
		text: 'Login',
		icon: 'HeroArrowRightOnRectangle',
	},
	signupPage: {
		id: 'signupPage',
		to: '/signup',
		text: 'Signup',
		icon: 'HeroArrowRightOnRectangle',
	},
	forgotPasswordPage: {
		id: 'forgotPasswordPage',
		to: '/forgot-password',
		text: 'Forgot Password',
		icon: 'HeroArrowRightOnRectangle',
	},
	resetPasswordPage: {
		id: 'resetPasswordPage',
		to: '/reset-password/:token',
		text: 'Reset Password',
		icon: 'HeroArrowRightOnRectangle',
	},
	verifyEmailPage: {
		id: 'verifyEmailPage',
		to: '/verify-email/:token',
		text: 'Verify Email',
		icon: 'HeroArrowRightOnRectangle',
	},
	notFoundPage: {
		id: 'notFoundPage',
		to: '/not-found',
		text: 'Not Found',
		icon: 'HeroArrowRightOnRectangle',
	},
	recordingDemo: {
		id: 'recording',
		to: '/demorecording',
		text: 'recording_Patient_video',
		icon: 'HeroArrowRightOnRectangle',
	},
};

const pagesConfig = {
	...authPages,
};

export default pagesConfig;
